// Centralized localStorage keys. Keeping these in one place avoids typos and
// keeps writers/readers of the same key in sync across pages.

// Pending company-invite token, stashed by AcceptInvitePage so the invite
// survives the redirect to registration/login and can be applied afterwards.
export const INVITATION_TOKEN_KEY = 'invitation_token';
